import React from 'react'
import { PageNotFound } from '../../../errors/PageNotFound/PageNotFound'

export const TheWestPageNotFound = () => <PageNotFound attribution />
